import { IconButton, InputAdornment, Typography } from '@material-ui/core';
import IconVisibility from '@material-ui/icons/Visibility';
import IconVisibilityOff from '@material-ui/icons/VisibilityOff';
import PropTypes from 'prop-types';

import { CUSTOM_BUTTON_SIZE, CustomButton } from 'src/components/CustomButton';
import CustomLink from 'src/components/CustomLink';
import { CustomMarkdown } from 'src/components/CustomMarkdowm';
import CustomTextField from 'src/components/CustomTextField';
import ErrorPanel from 'src/components/ErrorPanel';
import { ROUTES } from 'src/routes';

import { useStyles } from './useStyles';
import { useViewModel } from './useViewModel';

const LoginForm = ({ classes, loading, error, onSubmit }) => {
  const styles = useStyles({ classes });

  const {
    handleSubmit,
    showErrors,
    formFields,
    updateField,
    formErrors,
    showPassword,
    toggleShowPassword,
  } = useViewModel({ onSubmit, error });

  return (
    <form
      className={styles.root}
      onSubmit={handleSubmit}
      data-testid="LoginForm"
    >
      {showErrors && error && (
        <ErrorPanel
          classes={{ root: styles.errorPanel }}
          type="warning"
          text={<CustomMarkdown text={error} />}
        />
      )}

      <CustomTextField
        autoFocus
        className={styles.field}
        placeholder="Email address"
        id="email"
        value={formFields.email}
        onChange={(event) => updateField('email', event.target.value)}
        error={showErrors && Boolean(formErrors.email)}
        helperText={showErrors && formErrors.email}
        label="Email"
        margin="normal"
        variant="outlined"
        disabled={loading}
        fullWidth
        dataTestId="loginFormEmailInput"
        InputLabelProps={{
          classes: { root: styles.label },
        }}
      />

      <CustomTextField
        className={styles.field}
        id="password"
        type={showPassword ? 'text' : 'password'}
        value={formFields.password}
        onChange={(event) => updateField('password', event.target.value)}
        error={showErrors && Boolean(formErrors.password)}
        helperText={showErrors && formErrors.password}
        label="Password"
        margin="normal"
        variant="outlined"
        disabled={loading}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={toggleShowPassword}
                data-testid="LoginFormShowPasswordButton"
              >
                {showPassword ? <IconVisibilityOff /> : <IconVisibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        disallowLogRocket
        dataTestId="loginFormPasswordInput"
        InputLabelProps={{
          classes: { root: styles.label },
        }}
      />

      <Typography
        className={styles.forgotPassword}
        variant="body2"
      >
        <CustomLink
          to={ROUTES.RESET_PASSWORD}
          className={styles.link}
          data-testid="LoginForm__ResetPassword"
        >
          Forgot password?
        </CustomLink>
      </Typography>

      <CustomButton
        className={styles.button}
        loading={loading}
        disabled={loading}
        size={CUSTOM_BUTTON_SIZE.large}
        type="submit"
        data-testid="loginFormSubmitButton"
        fullWidth
      >
        Log in
      </CustomButton>
    </form>
  );
};

LoginForm.propTypes = {
  classes: PropTypes.shape({}),
  loading: PropTypes.bool,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

LoginForm.defaultProps = {
  classes: null,
  loading: null,
  error: null,
};

export default LoginForm;
